<ng-select #autoComplete [items]="searchResults$ | async" [addTag]="false" [multiple]="false" [hideSelected]="true"
    [loading]="searchLoading" [typeahead]="searchInput$" [appendTo]="'body'"
    [placeholder]="'settings.search-by-product-name-or-sku' | translate" (change)="selectResult($event)">
    <ng-template ng-option-tmp let-item="item">
        <div class="flex gap-2">
            <div class="w-8 h-8">

                <img *ngIf="item.featuredAsset;else placeholder" class="object-contain"
                    [src]="item.featuredAsset.preview">

                <ng-template #placeholder>
                    <div class="placeholder">
                        <clr-icon shape="image" size="50"></clr-icon>
                    </div>
                </ng-template>
            </div>
            {{ item.translations[0].name }}
            <small class="sku">{{ item.sku }}</small>
        </div>
    </ng-template>
</ng-select>
